import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b0cc1f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relation-header__content" }
const _hoisted_2 = { class: "inputs-group" }
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "search",
        class: "relation-header__search",
        placeholder: "Pesquisar por nome...",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('searching', $event.target.value))),
        "data-search-input": ""
      }, null, 32),
      _renderSlot(_ctx.$slots, "filters", {}, undefined, true)
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(['relation-header__btn', { disabled: _ctx.disabledSaveButton }]),
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"])),
      disabled: _ctx.disabledSaveButton
    }, _toDisplayString(_ctx.buttonTitle), 11, _hoisted_3)
  ]))
}